import { httpClient } from '../HttpClients';

export const fetchWelcomeMessage = async (pilotName: string) => {
    const { data } = await httpClient.get(`welcome_message/${pilotName}`);
    return data;
};
